import client from '../httpClient';

const schedulesDeleteApi = (scheduleId) => {
  return client.delete(`/schedules/${scheduleId}`, { isShowLoading: false });
};

export default schedulesDeleteApi;
